export const enum NOTIFICATIONS {
  addressSaved = 'CHECKOUT.ADDRESS.NOTIFICATIONS.SAVE_SUCCESS',
}

export const ADDRESS_UPDATE = {
  addressKey: 'address',
  asDefaultShippingKey: 'asDefaultShipping',
  asDefaultBillingKey: 'asDefaultBilling',
  shippingType: 'shipping',
  billingType: 'billing',
};

export const ADDRESS_TYPES = {
  shippingAddress: 'CHECKOUT.ADDRESS.SHIPPING.TITLE',
  billingAddress: 'CHECKOUT.ADDRESS.BILLING.TITLE',
};

export const ADDRESS_FIELDS = {
  addressLine2: 'REGULAR.FIELDS.ADDRESS_ADDITIONAL_INFORMATION.LABEL',
  city: 'REGULAR.FIELDS.CITY.LABEL',
  companyName: 'SHARED.ADDRESS.COMPANY_NAME.LABEL',
  country: 'REGULAR.FIELDS.COUNTRY.LABEL',
  firstName: 'REGULAR.FIELDS.FIRST_NAME.LABEL',
  houseNumber: 'REGULAR.FIELDS.HOUSE_NUMBER',
  lastName: 'REGULAR.FIELDS.LAST_NAME.LABEL',
  postalCode: 'REGULAR.FIELDS.POSTAL_CODE.LABEL',
  street: 'REGULAR.FIELDS.STREET',
  stateOrProvince: 'REGULAR.FIELDS.PROVINCE.LABEL',
  taxNumber: 'REGULAR.FIELDS.TAX_NUMBER',
};

export const ADDRESS_RESTRICTED_POSTAL_CODE_ALERT_ERROR_TITLE =
  'CHECKOUT.ADDRESS.RESTRICTED_POSTAL_CODE.ALERT.ERROR.TITLE';
